<template>
	<div class="nav">
		<div class="nav-wrapper">
      <div class="company-info-wrapper" @click="tabClick({ label: '首页', name: 'home' })">
        <div>
          <img src="img/logo_10257.jpg" style="cursor: pointer;"/>
        </div>
        <!-- <div class="menu-items-line1"></div>
        <div>
          <div class="company-info-wrapper-title">{{ companyName }}</div>
          <div class="company-info-wrapper-title">电子采购与招标平台</div>
        </div> -->
      </div>

      <ul class="nav-bar-wrapper">
        <li v-for="(item, index) in menuList" :key="index">
          <div class="ycl-nav-li" :class="currentTab === item.label ? 'active' : ''" @click="tabClick(item)">{{item.label}}</div>
        </li>
      </ul>

      <div class="toggle-search">
        <a-input placeholder="请输入您想搜的内容"
          v-model="searchInput"
          @focus="searchFlag=true"
          @blur="searchFlag=false"
          class="input-with-select">
          <a-select v-model="searchSelect" slot="addonBefore" placeholder="请选择" style="width: 140px">
            <a-select-option v-for="item in tabList" :key="item.key" :value="item.key">{{ item.label }}</a-select-option>
          </a-select>
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor:pointer;"  @click="handleSearch"></i>
        </a-input>
      </div>
    </div>
	</div>
</template>

<script>
import { store } from '@ice/stark-data'
import { noticeTypeList, publicityTypeList, intentionalSurveyTypeList, lxSelfBiddingNoticeTypeList } from '@/utils/config'

export default {
	name: 'yzNav',
	data() {
		return {
			searchInput: '',
			searchSelect: '所有公告',
			menuList: [
				{ label: '首页', name: 'home' },
				{ label: '采购信息', name: 'purchaseInfo', detail: 'noticeContent' },
				{ label: '政策法规', name: 'policy' },
				// { label: '公司信息', name: 'companyInfo' },
				{ label: '新手指南', name: 'helpCenter', detail: 'infoDetail' },
        { label: '交流互动', name: 'communication' }
      ],
      tabList: [
        { label: '所有公告', key: '所有公告' },
        ...noticeTypeList,
        ...publicityTypeList,
        ...intentionalSurveyTypeList,
        ...lxSelfBiddingNoticeTypeList
			],
			currentTab: '首页',
			token: ''
		}
	},
	methods: {
		tabClick(item) {
			this.currentTab = item.label
			this.$router.push({ name: item.name })
		},
		handleSearch() {
      store.set('nTitle', this.searchInput)
      store.set('nType', this.searchSelect)
      this.searchInput = ''
			this.$router.push({ name: 'purchaseInfo' })
		},
		// login() {
    //   window.location.href = `${window.urlConfig.sources.mainUrl}/basic/login/`
		// },
		// register() {
    //   window.location.href = `${window.urlConfig.sources.mainUrl}/basic/login/register`
		// }
	},
  watch: {
    $route (to) {
      const name = to?.name || ''
      if(!name) return
      const label = this.menuList.find(v => v.name === name || v.detail === name )?.label || null
      if(label) this.currentTab = label
    }
  },
  computed: {
    companyName() {
      return window.urlConfig?.web?.companyName
    }
  }
}
</script>
<style lang="less" scoped>
.nav {
  background-color: #fff;
  width: 100%;
  position: -webkit-sticky; /* 兼容性写法 */
  position: sticky;
  top: 0;
  z-index: 99;
  .nav-wrapper {
    display: flex;
    width: 1280px; // 1440px;
    height: 80px;
    justify-content: space-between;
    margin: 0 auto;
    .company-info-wrapper {
      display: flex;
      width: 442px;
      padding: 10px 0;
      img {
        // width: 400px;
        // height: 60px;
        width: 374px;
        height: 60px;
      }
      .menu-items-line1 {
        height: 40px;
        width: 2px;
        background-color: #dedede;
        margin: 10px 14px 0;
      }
      .company-info-wrapper-title {
        cursor: pointer;
        font-size: 21px;
        font-weight: 600;
        color: #333333;
      }
    }

    .nav-bar-wrapper {
      display: flex;
      .ycl-nav-li {
        padding: 0 15px;
        font-size: 16px;
        cursor: pointer;
        line-height: 80px;
      }
      .active {
        background-color: #ddf1f5;
        transition: all .3s;
        color: #42A5B6;
      }
    }

    .toggle-search {
      display: flex;
      align-items: center;
    }
  }
}
</style>
